import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import { Container, Row, Col } from "../Grid"
import Snippet from "../Snippet"
import ImageContentful from "../ImageContentful"

import { media, mixins } from "../../styles"

const Wrapper = styled.div``

const Header = styled.div`
  margin: 0 0 30px;
  text-align: center;

  @media ${media.md} {
    margin: 0 0 40px;
  }

  @media ${media.lg} {
    margin-bottom: 50px;
  }

  @media ${media.xl} {
    margin-bottom: 70px;
  }

  h2 {
    ${mixins.title3}
  }
`

const Item = styled.div`
  margin: 0 0 40px;
  text-align: center;

  @media ${media.md} {
    margin: 0 0 65px;
    padding: 0 25px;
  }

  h3 {
    ${mixins.copy4}
  }
`

const Icon = styled.div`
  margin: 0 auto 20px;
  height: 48px;
  width: 48px;

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`

const Extra = styled.div`
  background: var(--color-greyLight);
  padding: 55px 0 70px;
  text-align: center;

  h3 {
    ${mixins.title4}
  }

  p {
    ${mixins.copy4}
  }
`

const EmployeeBenefits = ({ benefits }) => {
  return (
    <Wrapper>
      <Container>
        <Header>
          <h2>
            <Snippet id="careersBenefitsHeader" field="header" />
          </h2>
        </Header>
        <Row>
          <Col lg="10" lgOffset="1">
            <Row>
              {benefits.map((benefit, i) => (
                <Col sm="6" md="4" lg="3" key={i}>
                  <Item>
                    <Icon aria-hidden="true">
                      <ImageContentful alt="" image={benefit.icon} inline />
                    </Icon>
                    <h3>{benefit.title}</h3>
                  </Item>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>

      <Extra>
        <Container>
          <Row>
            <Col lg="8" lgOffset="2">
              <h3>
                <Snippet id="careersRemoteWork" field="header" />
              </h3>
              <Snippet id="careersRemoteWork" field="text" md />
            </Col>
          </Row>
        </Container>
      </Extra>
    </Wrapper>
  )
}

EmployeeBenefits.propTypes = {
  benefits: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.object,
    })
  ),
}

export default EmployeeBenefits
